import { SaveDataKeys } from './SaveDataKeys';
import { StoryProgressManager } from './saveData/StoryProgressManager';
import { Events } from '../Events';
import { SceneManager } from './SceneManager';
import { Reward, RewardItem } from '../reward/Reward';
import { getRandomFromInterval } from '../../utils/MathUtils';
import { GameAnalytics, ResourceAquireType } from '../../analytics/GameAnalytics';
import gameanalytics = require('gameanalytics');

export enum ResourceName {
    Lives = 'Lives',
    ExtraMoves = 'ExtraMoves',
    NoAdsPass = 'NoAdsPass',
}

export enum CurrencyName {
    Coins = 'Coins'
}

export type InventoryData = Resource[];

export interface Resource {
    name: string;
    amount: number;
    maxAmount: number;
    buyable?: boolean;
    locked?: boolean;
}

export interface OfferDetails {
    amount: number;
    price: number;
}

export interface ItemOffer {
    name: string;
    icon: string;
    description: string;
    offers: OfferDetails[];
}

export class Inventory {
    private static _instance: Inventory;
    // time in seconds
    private readonly lifeRegenTime: number = 1800;
    // private readonly lifeRegenTime: number = 60;
    private resources: Map<CurrencyName, Resource> = new Map<CurrencyName, Resource>();

    private constructor() {
        if (GameAnalytics.getInstance().isTester()) {
            // this.lifeRegenTime = 60;
        }
    }

    public getRewardedAdReward(): Reward {
        const rewards: RewardItem[] = [];
        const coins: RewardItem = {
            resourceName: CurrencyName.Coins,
            amount: getRandomFromInterval(100, 120)
        };
        rewards.push(coins);
        return new Reward(rewards);
    }

    public getAmount(name: CurrencyName | ResourceName): number {
        if (this.resources[name] && this.resources[name].amount) {
            return this.resources[name].amount;
        }
        return 0;
    }

    public getPrice(resourceName: CurrencyName | ResourceName): number {
        const offerJson: JSON = SceneManager.getInstance().getJson('offers');
        const offer: ItemOffer = offerJson[resourceName];
        const offerDetails: OfferDetails = offer.offers[0];
        return offerDetails.price;
    }

    public isLocked(name: CurrencyName | ResourceName): boolean {
        if (this.resources[name] && this.resources[name].locked !== undefined && this.resources[name].locked !== null) {
            return this.resources[name].locked;
        }
        return true;
    }

    public buyResource(resourceName: CurrencyName | ResourceName, offerID: number, chapter: number): void {
        const offerJson: JSON = SceneManager.getInstance().getJson('offers');
        const offer: ItemOffer = offerJson[resourceName];
        const offerDetails: OfferDetails = offer.offers[offerID];
        const currentCoins: number = this.getAmount(CurrencyName.Coins);
        if (currentCoins >= offerDetails.price) {
            this.addAmount(CurrencyName.Coins, -offerDetails.price);
            this.addAmount(resourceName, offerDetails.amount);
        } else {
            throw new Error('SOMEHOW GOT TO TRY TO BUY RESOURCE WITH INSUFFICIENT COINS');
        }
    }

    public addAmount(name: ResourceName | CurrencyName, amount: number): boolean {
        let success: boolean = true;
        const resource: Resource = this.resources[name];
        if (resource.amount + amount <= resource.maxAmount) {
            if (resource.amount + amount >= 0) {
                resource.amount = resource.amount + amount;
            } else {
                success = false;
            }
        } else {
            resource.amount = resource.maxAmount;
        }
        if (success) {
            dispatchEvent(new CustomEvent(Events.updatedResourceAmount, {
                detail: {
                    resourceName: resource.name,
                    amount: resource.amount
                }
            }));
            this.saveData();
        }
        return success;
    }

    public static getInstance(): Inventory {
        return this._instance || (this._instance = new this());
    }

    public async init(): Promise<any> {
        return FBInstant.player
            .getDataAsync([SaveDataKeys.inventory, SaveDataKeys.livesRegenTimeStamp]).then((result: any) => {
                    let inventoryData: InventoryData = result.inventory;
                    if (!inventoryData || inventoryData.length === 0) {
                        this.initData();
                    } else {
                        inventoryData = this.initAdsPass(inventoryData);
                        this.setLocalData(inventoryData);
                    }
                }
            );
    }

    private initAdsPass(inventory: InventoryData): InventoryData {
        let hasAdsPass: boolean = false;
        inventory.forEach((item: Resource) => {
            if (item.name === ResourceName.NoAdsPass) {
                hasAdsPass = true;
            }
        });
        if (!hasAdsPass) {
            const iapItem: Resource = {
                name: ResourceName.NoAdsPass,
                amount: 0,
                maxAmount: 1
            };
            inventory.push(iapItem);
        }

        return inventory;
    }

    public initData(): void {
        const inventoryData: InventoryData = [];
        const lives: Resource = {
            name: ResourceName.Lives,
            amount: 5,
            maxAmount: 5
        };
        const coins: Resource = {
            name: CurrencyName.Coins,
            amount: 100,
            maxAmount: 99999
        };
        const noAdsPass: Resource = {
            name: ResourceName.NoAdsPass,
            amount: 0,
            maxAmount: 1
        };
        inventoryData.push(lives, coins, noAdsPass);
        FBInstant.player
            .setDataAsync({
                inventory: inventoryData
            });
        inventoryData.forEach((item: Resource): void => {
            dispatchEvent(new CustomEvent(Events.updatedResourceAmount, {
                detail: {
                    resourceName: item.name,
                    amount: item.amount
                }
            }));
        });
        this.setLocalData(inventoryData);
    }

    private setLocalData(data: InventoryData): void {
        data.forEach((resource: Resource) => {
            // if (resource.name === ResourceName.Lives) {
            //   resource.amount = 0;
            // }
            // if (resource.name === CurrencyName.Coins) {
            //   resource.amount = 0;
            // }
            this.resources[resource.name] = resource;
        });
    }

    private saveData(): void {
        const data: InventoryData = [];
        Object.keys(this.resources).forEach((key: CurrencyName) => {
            data.push(this.resources[key]);
        });
        FBInstant.player
            .setDataAsync({
                inventory: data
            });
    }
}